import React, { useState, useEffect, useRef } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { AnchorSection } from 'react-anchor-navigation';
import { Props } from './interfaces';
import './BlockCalculator.scss';
import './BlockCalculator-media.scss';
import Calculator from '../Calculator/Calculator';
import Content from '../Content/Content';
import CalculatorTable from '../CalculatorTable/CalculatorTable';
import { MediaContent } from '../../services/GlobalFunctions';
import {content} from "../../services/content";

const BlockCalculator = ({ calculator, alertLoaded }: Props) => {
  const { KurDalli, KurSdek, PvzBoxberry, PvzSdek, Pvz5post, RuPost } = calculator;

  const [valueFrom, setValueFrom] = useState('Москва');
  const [valueIn, setValueIn] = useState('');
  const [showTable, setShowTable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const resultRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let errorsCount = 0;
    [KurDalli, KurSdek, PvzBoxberry, PvzSdek, Pvz5post, RuPost].forEach((item) => {
      if (item.errormsg) {
        errorsCount++;
      }
    });

    if (errorsCount === 6) {
      setShowTable(false);
      alertLoaded([content.common.alertByParameter, `${KurSdek.errormsg}`]);
    }

    if (isLoading) {
      setIsLoading(false);
      setTimeout(() => {
        resultRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [calculator]);

  const handleCalculate = () => {
    setIsLoading(true);
    setShowTable(true);
  };

  return (
    <>
      <Calculator
        buttonOnClick={handleCalculate}
        setCityFrom={setValueFrom}
        setCityIn={setValueIn}
        isLoading={isLoading}
      />
      <div className="block-calculator__bg"></div>

      <div ref={resultRef}>
        <AnchorSection id="result">
          {showTable
            ? MediaContent(
                <Content
                  padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 0, bottom: 40 } }}
                  block={<CalculatorTable valueFrom={valueFrom} valueIn={valueIn} />}
                />,
                <CalculatorTable valueFrom={valueFrom} valueIn={valueIn} />
              )
            : null}
        </AnchorSection>
      </div>
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(BlockCalculator));
